@if (!mappedItem.isDeleted) {
    <mat-card class="main-card flex-col flex">
        <mat-card-header class="start-start flex-row">
            <div class="header-icons start-center flex-row">
                <cb-lot-spec-item-icons [mappedItem]="mappedItem"></cb-lot-spec-item-icons>
                <span class="flex" layout-padding></span>
            </div>
            <div class="start-start flex-col flex">
                @if (!(mappedItem.isManualQuote && mappedItem.isQuoteCost)) {
                    <span class="mat-body-strong">{{
                        mappedItem.productDisplay | cbTruncate: 50
                    }}</span>
                }
                @if (mappedItem.isManualQuote && mappedItem.isQuoteCost) {
                    <span class="mat-body-strong">{{
                        mappedItem.quoteLineDescription | cbTruncate: 50
                    }}</span>
                }
                <span class="mat-caption">{{ mappedItem.productCode }}</span>
            </div>
            <div class="start-center flex-row">
                <h3 [matTooltip]="COST_TYPE_ENUM[mappedItem.costType]">
                    {{ COST_TYPE_ENUM[mappedItem.costType]?.substr(0, 1) }}
                </h3>
                @if (lotSpec?.isLocked) {
                    <mat-icon class="cb-grey" matTooltip="Locked"> lock </mat-icon>
                }
            </div>
        </mat-card-header>
        <mat-card-content class="card-content cb-padding-top mat-card-content-row">
            <div class="flex-col flex">
                <!-- only show qty if is actual cost -->
                @if (mappedItem.isActualCost) {
                    <cb-display-value-new
                        label="Qty"
                        [value]="mappedItem.quantity"
                    ></cb-display-value-new>
                }
                @if (mappedItem.isEstimatedCost) {
                    <cb-display-value-new
                        label="Estimated Cost"
                        [value]="mappedItem.rate"
                    ></cb-display-value-new>
                }
                @if (mappedItem.isProvisionalOrSpecificationQuoteItem) {
                    <cb-currency
                        label="Provisional Cost"
                        [ngModel]="mappedItem.rate"
                        [readonly]="true"
                        [inclGst]="true"
                    ></cb-currency>
                }
                @if (mappedItem.isProvisionalOrSpecificationQuoteItem) {
                    <cb-currency
                        label="Amount Spent"
                        [ngModel]="mappedItem.amountSpent"
                        [readonly]="true"
                        [inclGst]="true"
                    ></cb-currency>
                }
                @if (mappedItem.isNoChargeCost) {
                    <cb-currency
                        label="No Charge Cost"
                        [ngModel]="mappedItem.noChargeCost"
                        [readonly]="true"
                    >
                    </cb-currency>
                }
                @if (!mappedItem.isDescriptiveOnlyCost) {
                    <cb-display-value-new
                        label="Supplier"
                        [value]="mappedItem.supplierDisplay"
                    ></cb-display-value-new>
                }
                @if (mappedItem.productCategoryId > 0) {
                    <cb-display-value-new
                        label="Category"
                        [value]="mappedItem.productCategory"
                    ></cb-display-value-new>
                }
                @if (mappedItem.manualColourEntryRequired) {
                    <cb-display-value-new
                        label="Manual Colour"
                        [value]="mappedItem.colourName"
                    ></cb-display-value-new>
                }
                @if (mappedItem.offeringOptions?.length > 0) {
                    <div class="flex-col flex">
                        @for (option of mappedItem.offeringOptions; track option) {
                            <cb-display-value-new
                                [label]="option.category"
                                [value]="option.name"
                            ></cb-display-value-new>
                        }
                    </div>
                }
                @if (mappedItem.isDescriptiveOnlyCost) {
                    <cb-text-area
                        [ngModel]="mappedItem.productDisplay"
                        [readonly]="true"
                    ></cb-text-area>
                }
            </div>
            <div class="images flex-col">
                @if (!mappedItem.specItemImage) {
                    <cb-image-button class="flex" [baseUrl]="mappedItem.image"> </cb-image-button>
                }
                @if (mappedItem.specItemImage) {
                    <cb-image-button class="flex" [baseUrl]="mappedItem.specItemImage">
                    </cb-image-button>
                }
            </div>
        </mat-card-content>
        <mat-divider class="card-divider"></mat-divider>
        <mat-card-actions>
            <div class="flex-row flex layoutGap-16">
                @if (!uiActions.hideQrefsButton()) {
                    <button
                        mat-stroked-button
                        color="accent"
                        (click)="uiActions.quoteRefsDialog()"
                        [disabled]="!mappedItem.hasQuoteLines"
                    >
                        Q Refs
                    </button>
                }
                @if (mappedItem.isSsrConfirmed) {
                    <button
                        mat-stroked-button
                        color="accent"
                        (click)="uiActions.showPurchaseOrders()"
                    >
                        PO's
                    </button>
                }
                <span class="flex"></span>
                @if (uiActions.showSplitSpecItem()) {
                    <button
                        mat-stroked-button
                        color="accent"
                        (click)="uiActions.splitProduct()"
                        [disabled]="!mappedItem.canSplit"
                    >
                        Split
                    </button>
                }
                @if (uiActions.canChangeSpecification()) {
                    <button
                        mat-stroked-button
                        color="accent"
                        (click)="uiActions.editLotSpecItem()"
                        [disabled]="!mappedItem.canEdit"
                    >
                        Edit
                    </button>
                }
                @if (uiActions.canChangeSpecification()) {
                    <button
                        mat-stroked-button
                        (click)="uiActions.removeLotSpecItem()"
                        [disabled]="lotSpec?.isLocked"
                    >
                        Remove
                    </button>
                }
            </div>
        </mat-card-actions>
    </mat-card>
}
